<!--
  CONTACTOS DEL COMERCIO — pantalla propia, a todo el ancho.
  Superficie plana: `.kb-seccion` y `.kb-tabla-plana`, sin tarjeta alrededor.

  Salió el subtítulo «Con quién se habla en este comercio», que estaba debajo de
  un título que dice «Contactos».
-->
<!-- 🔴 SIN MIGA, SIN TÍTULO Y SIN ENVOLTORIO DE PÁGINA — 2026-09-20.
     Esta pantalla es una RUTA HIJA de la ficha del comercio y se dibuja dentro
     de su `<router-outlet>`. El padre ya pone la miga, el nombre del comercio,
     su estado, la tira del portal y la barra de pestañas: repetirlos acá los
     mostraba DOS VECES, uno debajo del otro, y además `kb-page` anidado dentro
     de `kb-page` duplicaba el relleno y el ancho máximo.
     Lo que sí queda acá son las ACCIONES de esta pantalla. -->
<div class="space-y-8">


  <!-- ══ Encabezado ═══════════════════════════════════════════════════════════ -->
  <!-- 🔴 LAS ACCIONES, A LA DERECHA Y CON AIRE. Juan, 2026-09-20: «el botón,
       cuando navegas entre pestañas, está a la izquierda y pegado».
       Era `kb-page-header`, que reparte título a la izquierda y acciones a la
       derecha con `justify-between`. Al sacarle el título —lo pone el padre—
       quedó UN SOLO hijo, y `justify-between` con uno solo lo manda al borde
       izquierdo. Acá se alinea a la derecha a propósito, y `pt-1` lo despega de
       la barra de pestañas de arriba. -->
  <div class="flex flex-wrap items-center justify-end gap-2 pt-2">

    <div class="flex shrink-0 flex-wrap items-center gap-2" *ngIf="!cargando && !noEncontrado">
      <!-- Se agregan y se cambian en el formulario del comercio, que es donde se
           guardan: aquí sólo se miran. -->
      <a class="kb-btn kb-btn-primary" *ngIf="puede('update')"
         [routerLink]="['/console/merchants', codigo, 'editar']">
        <i class="fas fa-pen" aria-hidden="true"></i>Editar los contactos
      </a>
    </div>
  </div>

  <!-- ══ Cargando ═════════════════════════════════════════════════════════════ -->
  <div *ngIf="cargando" class="space-y-4" aria-live="polite" aria-busy="true">
    <div class="kb-skeleton h-3 w-28"></div>
    <div class="kb-skeleton h-40 w-full"></div>
  </div>

  <!-- ══ No existe el comercio ════════════════════════════════════════════════ -->
  <div class="kb-empty" *ngIf="!cargando && noEncontrado">
    <span class="kb-empty-icono"><i class="fas fa-store-slash" aria-hidden="true"></i></span>
    <p class="kb-empty-titulo">No encontramos el comercio «{{ codigo }}»</p>
    <p class="kb-empty-texto">Puede que el código esté mal escrito.</p>
    <a class="kb-btn kb-btn-outline mt-4" [routerLink]="['/console/merchants']">
      <i class="fas fa-arrow-left" aria-hidden="true"></i>Volver a comercios
    </a>
  </div>

  <ng-container *ngIf="!cargando && !noEncontrado">

    <section class="kb-tarjeta">
      <div class="kb-tarjeta-cab">
        <h2 class="text-base font-semibold leading-none">Personas de contacto</h2>
      </div>
      <div class="kb-tarjeta-cuerpo">
      <div class="kb-tabla-plana" *ngIf="contactos.length">
        <table class="kb-table">
          <thead class="kb-thead">
            <tr>
              <th class="kb-th">Nombre</th>
              <th class="kb-th">Cargo</th>
              <th class="kb-th">Contacto</th>
            </tr>
          </thead>
          <tbody>
            <tr class="kb-tr" *ngFor="let c of contactos">
              <td class="kb-td kb-td-titulo">{{ c.name }} {{ c.lastname }}</td>
              <td class="kb-td">{{ c.position || '—' }}</td>
              <td class="kb-td">
                <a class="block text-primary hover:underline" *ngIf="c.email"
                   [href]="'mailto:' + c.email">{{ c.email }}</a>
                <span class="kb-td-sub" *ngIf="!c.email">Sin correo</span>
                <a class="kb-td-sub block hover:underline" *ngIf="c.phone"
                   [href]="'tel:' + c.phone">{{ c.phone }}</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="kb-empty" *ngIf="!contactos.length">
        <span class="kb-empty-icono"><i class="fas fa-address-book" aria-hidden="true"></i></span>
        <p class="kb-empty-titulo">Sin contactos cargados</p>
        <p class="kb-empty-texto">
          Es con quién se habla del lado del comercio cuando hay que resolver algo de sus
          ventas o de su liquidación.
        </p>
        <a class="kb-btn kb-btn-primary mt-4" *ngIf="puede('update')"
           [routerLink]="['/console/merchants', codigo, 'editar']">
          <i class="fas fa-plus" aria-hidden="true"></i>Agregar un contacto
        </a>
      </div>
      </div>
    </section>

  </ng-container>
</div>
